// @flow

import React, { PureComponent, type Element } from 'react';
import MemberNames from 'client/components/member/names';
import PlanCard from 'client/components/plan/card/planCard';
// import TypeAndDate from 'client/components/plan/card/typeAndDate';
import EffectiveDate from 'client/components/plan/card/effectiveDate';
import Price from 'client/components/price';
import { filterCoveredMembers } from 'client/utils/member';

type RibbonStatus = {
  content: string,
  classes?: Object,
};

type Props = {
  // type: string,
  children?: Element,
  className?: string,
  effectiveDate?: string | Date | null,
  isCard: boolean,
  members: Array<Object>,
  note?: Element,
  plan: Object,
  planName?: string,
  premium: number,
  ribbonStatus?: RibbonStatus,
};

class FunnelCard extends PureComponent<Props> {
  render() {
    const {
      children,
      className,
      effectiveDate,
      members,
      note,
      plan,
      planName,
      premium,
      ribbonStatus,
    } = this.props;

    const coveredMembers = filterCoveredMembers(members);
    const priceProps = {
      content: 'common.perMonth',
      classes: {
        // iconClass: 'icon-check-mark-circle',
        colorClass: 'navy-2-color',
      },
      price: premium,
      precision: 2,
    };

    return (
      <PlanCard status={ribbonStatus} className={className}>
        <div className="plan-details">
          <div className="medium-table navy-1-color v-bottom">
            <div className="td medium-6 basic-info margin-bottom">
              <h3
                className="carrier-name navy-1-color"
                style={{ fontSize: '1.4rem', lineHeight: 'initial' }}>
                {plan.carrier} {plan.name}
              </h3>
              {effectiveDate && <EffectiveDate date={effectiveDate} descriptor="common.start" />}
              {planName && <div className="plan-name">{planName}</div>}
              <h5 className="card-member-names navy-2-color" style={{ fontSize: '0.9rem' }}>
                <MemberNames memberNames={coveredMembers} />
              </h5>
              <div className="card-premium no-margin">
                <Price {...priceProps} />
              </div>
              {note}
            </div>
            {children}
          </div>
        </div>
      </PlanCard>
    );
  }
}

FunnelCard.defaultProps = {
  children: null,
  className: '',
  effectiveDate: null,
  isCard: false,
  note: null,
  planName: null,
  ribbonStatus: {},
};

export default FunnelCard;
